import React, { useEffect, useState } from "react";
import { MadfarmStaticSelect } from "../../../../ui/molecules/select/newSelect/static";
import { HourOptions, MinuteOptions } from "../../../../utils";
import { HoursMinutesBoxProps } from "./hoursMinutesBox.types";

export const HoursMinutesBox: React.FC<HoursMinutesBoxProps> = ({ ...props }) => {
    const [hours, setHours] = useState<number | undefined>(undefined)
    const [minutes, setMinutes] = useState<number | undefined>(undefined)

    useEffect(() => {
        if (props.defaultValue === undefined) return
        const hours_temp = Math.trunc(props.defaultValue)
        const minutes_temp = Math.round((props.defaultValue - hours_temp) * 60)
        setHours(hours_temp)
        setMinutes(minutes_temp)
    }, [])

    useEffect(() => {
        let res = hours ?? 0
        if (minutes) res += minutes / 60
        props.onChange?.(res)
    }, [hours, minutes])

    return (
        <div className="flex items-end gap-3">
            <div className="flex-1">
                <MadfarmStaticSelect
                    customZIndex={9999}
                    label="Ore"
                    noOptionsMessage=""
                    placeholder="ore..."
                    options={HourOptions}
                    value={String(hours)}
                    onChange={value => {
                        //@ts-ignore
                        const newValue = value !== null ? value.value : null
                        setHours(Number(newValue))
                    }}
                />
            </div>
            <div className="flex-1">
                <MadfarmStaticSelect
                    customZIndex={9999}
                    label="Minuti"
                    noOptionsMessage=""
                    placeholder="minuti..."
                    options={MinuteOptions}
                    value={String(minutes)}
                    onChange={value => {
                        //@ts-ignore
                        const newValue = value !== null ? value.value : null
                        setMinutes(Number(newValue))
                    }}
                />
            </div>
        </div>
    )
}